import React from "react";
import { Link } from "react-router-dom";
import { Loader2, ShieldAlert } from "lucide-react";
import { useMyCinema } from "../context/MyCinemaContext";
import { InnerNav } from "./InnerNav";
import { useTranslate } from "../context/TranslateContext";

// Gate a route to staff (admin/editor). Members and guests see an access screen.
export const RequireStaff = ({ children }) => {
  const { user, ready, isStaff, setAuthOpen } = useMyCinema();
  const { t } = useTranslate();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-paper">
        <Loader2 className="h-7 w-7 animate-spin text-gold" />
      </div>
    );
  }

  if (!isStaff) {
    return (
      <div className="min-h-screen bg-paper" data-testid="staff-denied">
        <InnerNav />
        <div className="mx-auto max-w-lg px-6 py-32 text-center">
          <ShieldAlert className="mx-auto h-10 w-10 text-gold" />
          <h1 className="mt-5 font-display text-3xl text-cream">{t("Staff access only")}</h1>
          <p className="mt-3 font-body text-ash">
            {user ? t("Your account doesn't have editor or admin permissions.")
                  : t("Please log in with an editor or admin account to continue.")}
          </p>
          <div className="mt-6 flex justify-center gap-3">
            {!user && (
              <button onClick={() => setAuthOpen(true)} data-testid="staff-login"
                className="rounded-full bg-gold px-6 py-3 font-body font-medium text-ink transition-transform hover:scale-105">
                {t("Log in")}
              </button>
            )}
            <Link to="/" className="rounded-full border border-edge px-6 py-3 font-body text-cream hover:border-gold hover:text-gold">
              {t("Back to home")}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return children;
};
